import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'

import languages from '../views/LangWrapper/languages'
import store from '../store/index'

Vue.use(VueI18n)

if (store.getters.lang === undefined){
  
  // browser language
  let navLang = window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage
  navLang = languages.includes(navLang) ? navLang.split('-')[0] : undefined
  // page language
  const locationLang = languages.includes(window.location.pathname.split('/')[1])
  ? window.location.pathname.split('/')[1]
  : undefined

  if ( locationLang !== undefined ) store.commit('changeLanguage', locationLang)
  else if ( navLang !== undefined ) store.commit('changeLanguage', navLang)
  else store.commit('changeLanguage', languages[0])
  
  // store.commit('changeLanguage', 'it')
}
// da togliere riattivando le due lingue (oltre alla riga sopra, da rimettere il commentato)
// store.commit('changeLanguage', 'it')

const i18n = new VueI18n({
  locale: store.getters.lang,
  messages
})
export default i18n
